// bytesToSize
// https://gist.github.com/lanqy/5193417

const SIZES = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
const KILOBYTE_IN_BYTES = 1024;

export default function bytesToSize(value) {
  const bytes = Number(value);
  if (bytes === 0 || Number.isNaN(bytes)) return 'n/a';
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(KILOBYTE_IN_BYTES)), 10);
  if (i === 0) return `${bytes} ${SIZES[i]}`;
  return `${(bytes / (KILOBYTE_IN_BYTES ** i)).toFixed(1)} ${SIZES[i]}`;
}
